var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_23810)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.5195,
    cy: 27,
    r: 21,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_23810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9319 22.6394C36.3347 22.9013 35.6984 23.075 35.0349 23.1593C35.7174 22.7518 36.2383 22.1115 36.4832 21.3396C35.8469 21.719 35.1443 21.987 34.3956 22.1365C33.7914 21.4932 32.9302 21.0947 31.9908 21.0947C30.1681 21.0947 28.7007 22.5741 28.7007 24.3878C28.7007 24.6487 28.7228 24.8997 28.777 25.1385C26.04 25.0051 23.6181 23.6932 21.9911 21.6949C21.7071 22.1877 21.5405 22.7518 21.5405 23.359C21.5405 24.4992 22.1276 25.5099 23.0028 26.095C22.4739 26.085 21.955 25.9314 21.5154 25.6896C21.5154 25.6996 21.5154 25.7126 21.5154 25.7257C21.5154 27.3256 22.6566 28.6544 24.1531 28.9605C23.8851 29.0338 23.593 29.0689 23.2899 29.0689C23.0791 29.0689 22.8663 29.0569 22.6666 29.0127C23.0932 30.3165 24.3036 31.275 25.7429 31.3061C24.6228 32.1823 23.2006 32.7103 21.6609 32.7103C21.3909 32.7103 21.132 32.6982 20.873 32.6651C22.3314 33.6056 24.0597 34.1425 25.9235 34.1425C31.9817 34.1425 35.2939 29.1241 35.2939 24.7742C35.2939 24.6287 35.2889 24.4882 35.2818 24.3486C35.9352 23.8849 36.4842 23.3058 36.9319 22.6394Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_23810",
    x: 0.671875,
    y: 0.394531,
    width: 57.6953,
    height: 57.6953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.24219
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.92383
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_23810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_23810",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_23810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0588,
    height: 16.0588,
    fill: "white",
    transform: "translate(20.8809 19.5884)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.19d36cf298b03e0274be912b76e4ff2a.svg";
export { ForwardRef as ReactComponent };